<template>
  <div
    class="ks-overlay ks-static"
    :class="`ks-static-${$route.params.route}`"
    ref="scrollContainer"
    v-on:scroll.passive="$root.measure($event, $refs.scrollTarget)"
  >
    <div class="ks-overlay-hitarea" v-on:mouseover="$root.hitareaActive = true" v-on:mouseout="$root.hitareaActive = false"  v-on:click="$router.push({name:'home'})"/>
    <div class="ks-overlay-container" ref="scrollTarget" :class="{'ks-overlay-container-top': $root.scrollOffset === false}">
      <Closetag v-bind:force="'home'" v-bind:hasnav="submenu.length > 2" v-if="data.length > 0"/>
      <div class="ks-overlay-container-stickyhead ks-overlay-container-stickyhead-responsive ks-static-nav" ref="staticnav" v-if="submenu.length > 2 && data.length > 0">
        <div class="ks-overlay-container-stickyhead-wrapper">
          <router-link
            v-for="d in submenu"
            :ref="`bt-${d._id}`"
            :key="`bt-${d._id}`"
            :to="{name: 'overlay', params: {route: $route.params.route, id: d._id, stub: d._name}}"
            class="ks-round-button ks-round-button-zoom"
            :class="{'ks-round-button-active': active == `bt-${d._id}`}"
          >
            <span v-on:click="jump(d._id)">{{d._name}}</span>
          </router-link>
        </div>
      </div>
      <div class="ks-static-entry" v-for="(d, dk) in data" :key="d._id" :ref="`entry-${d._id}`">
        <div
          v-if="d.Titel"
          :data-key="dk"
          :data-active="`bt-${d._id}`"
          class="ks-overlay-container-head"
          v-observe-visibility="{
            callback: visibilityChanged,
            intersection: {
              threshold: 1.0
            }
          }"
          >
          <h1 v-html="d.Titel"/>
        </div>
        <div v-else class="ks-overlay-container-spacer"/>
        <div class="ks-roundbox" v-if="d.Text">
          <div class="ks-overlay-container-small" v-html="d.Text"/>
        </div>
        <div class="ks-roundbox ks-roundbox-plaintext" :class="{'ks-roundbox-plaintext-scrolling': $root.isScrolling === true}" v-if="d.Plaintext" v-html="d.Plaintext"/>
        <div class="ks-roundbox ks-roundbox-lined" v-if="d.LinienText">
          <div class="ks-overlay-container-small" v-html="d.LinienText"/>
        </div>
        <div class="ks-overlay-container-gallery"  v-if="d.Bilder && d.Bilder.length > 0">
          <swiper :key="`mySwiperId-${d._id}`" :ref="`mySwiper${d._id}`" :options="d.Bilder.length === 1 ? swiperOptionsSingle : swiperOptions">
            <swiper-slide v-for="(i,ik) in d.Bilder" v-bind:key="`${d._id}-${ik}`" :data-caption="i.Captions[0]" :data-ref="`caption-${d._id}`">
              <img :width="i.Sizes[0]" :height="i.Sizes[1]" :src="i.Resized[2]"/>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
          <span class="caption" v-html="captions[`caption-${d._id}`] || ''"/>
        </div>
        <div class="ks-roundbox" v-if="d.TabularText && d.TabularText.length > 0">
          <div class="ks-overlay-container-small">
            <div class="ks-sticky-list" v-for="(r, rk) in d.TabularText" v-bind:key="`sticky-${rk}`">
              <div class="ks-sticky-list-float" v-html="r[0].nl2br()"/>
              <div class="ks-sticky-list-content" v-html="r[1].nl2br()"/>
            </div>
          </div>
        </div>
        <div class="ks-roundbox ks-roundbox-nopadding" v-if="d.Links && d.Links.length > 0">
          <div class="ks-green-button-wrapper"  v-for="(l, lk) in d.Links" v-bind:key="`linkrow-${lk}`">
            <a class="ks-green-button ks-green-button-autoheight" :href="l[0]" target="_blank"><span>{{l[1]}}</span></a>
          </div>
        </div>
        <template v-if="d.Flipcards && d.Flipcards.length > 0">
          <div class="ks-flipcard" v-for="(i,ik) in d.Flipcards" v-bind:key="ik">
            <img :src="i.Resized[2]"/>
            <div class="ks-roundbox">
              <div class="ks-sticky-list">
                <div class="ks-sticky-list-float" v-html="i.Captions[0]"/>
                <div class="ks-sticky-list-content" v-html="i.Captions[1]"/>
              </div>
              <div class="ks-sticky-list">
                <div v-html="i.Captions[2]"/>
              </div>
            </div>
          </div>
        </template>
        <div class="ks-overlay-container-inset"  v-if="d.Downloads && d.Downloads.length > 0">
          <template v-for="dw in d.Downloads">
            <a class="bigdownload" :class="{'bigdownload-icon': !file.Resized}" v-for="(file, filekey) in dw.Download" target="_blank" :href="file.Original" v-bind:key="`download-${dw._id}-${filekey}`">
              <div>
                <img v-if="file.Resized" :src="file.Resized[1]"/>
              </div>
              <span v-html="file.Captions[0]"/>
            </a>
          </template>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
/* eslint-disable */

import Closetag     from '../components/Closetag.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Footer       from '../components/Footer.vue'
import {scroller} from 'vue-scrollto/src/scrollTo'
const headerScroller = scroller()

export default {
  name: 'Static',
  components: {
    Closetag,
    Swiper,
    SwiperSlide,
    Footer
  },
  computed: {
    submenu() {
      if (this.data && this.data.length > 2) {
        return this.data.filter((e) => e.Titel)
      }
      return [];
    }
  },
  data () {
    let _self = this;
    return {
      data: [],
      captions: {},
      swiperOptions: {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        on: {
          transitionEnd: function(a) {
            try {
              let _d = this.slides[this.realIndex].dataset;
              _self.$set(_self.captions,_d.ref,_d.caption);
            } catch (err) {
              console.warn(err)
            }
          },
          init: function() {
            try {
              let _d = this.slides[this.realIndex].dataset;
              _self.$set(_self.captions,_d.ref,_d.caption);
            } catch (err) {
              console.warn(err)
            }
          }
        },
        slidesPerView: "auto",
        // centeredSlides: true,
        // enterInsufficientSlides: true,
        loop: true,
        spaceBetween: 30,
        keyboard: true
      },
      swiperOptionsSingle: {
        on: {
          transitionEnd: function(a) {
            try {
              let _d = this.slides[this.realIndex].dataset;
              _self.$set(_self.captions,_d.ref,_d.caption);
            } catch (err) {
              console.warn(err)
            }
          },
          init: function() {
            try {
              let _d = this.slides[this.realIndex].dataset;
              _self.$set(_self.captions,_d.ref,_d.caption);
            } catch (err) {
              console.warn(err)
            }
          }
        },
        watchOverflow: true,
        centeredSlides: true
      },      
      active: ''
    }
  },
  mounted() {
    this.$http(`static/${this.$route.params.route}`).then((d) => {
      this.data = d.data
      try {
        if (!this.data[0]._id) {
          this.$router.push('/')
          return;
        }
      } catch (err) {
        this.$router.push('/')
        return;
      }
      this.$nextTick(()=>{
        if (this.$root.scrollOffset === true) {
          var options = {
              container: this.$refs.scrollContainer,
              easing: [0.34, 1.56, 0.64, 1],
              lazy: false,
              offset: document.documentElement.clientHeight * -.5,
              force: true,
              cancelable: true,
              x: false,
              y: true
          }
          this.$scrollTo(this.$refs.scrollTarget, 350, options)
          if (this.data[0].Meta) {
            this.$root.applyMeta(
                `Kulturstiftung Thurgau ⚡️ ${this.data[0].Meta[0]}`,
                this.data[0].Meta[1] || "",
                this.data[0].Meta[2] || "",
                this.data[0].Bilder && this.data[0].Bilder.length ? this.data[0].Bilder[0].Resized[2] : false
            )
          }
        }
        else {
          if (this.$route.params.id) {
            this.data.forEach(d => {
              if (d._id == this.$route.params.id && d.Meta) {
                this.$root.applyMeta(
                    `Kulturstiftung Thurgau ⚡️ ${d.Meta[0]}`,
                    d.Meta[1] || "",
                    d.Meta[2] || "",
                    d.Bilder && d.Bilder.length ? d.Bilder[0].Resized[2] : false
                )  
              }
            })
            this.jump(this.$route.params.id)
          }
        }
        this.$root.overlayOpen   = true;
      })      
    }, (err) => {
      this.$router.push('/')
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$root.scrollOffset = false;
    this.$root.$emit('overlay:close', true);
    this.$root.applyMeta();
    next();
  },
  methods: {
    visibilityChanged (isVisible, entry) {
      try {
        let _i = entry.target;
        if (isVisible) {
          this.active = _i.dataset.active;
          if (this.data[_i.dataset.key].Meta) {
            this.$root.applyMeta(
                `Kulturstiftung Thurgau ⚡️ ${this.data[_i.dataset.key].Meta[0]}`,
                this.data[_i.dataset.key].Meta[1] || "",
                this.data[_i.dataset.key].Meta[2] || "",
                this.data[_i.dataset.key].Bilder && this.data[_i.dataset.key].Bilder.length ? this.data[_i.dataset.key].Bilder[0].Resized[2] : false
            )
          }
          if (this.$refs.staticnav) {
            var options = {
                container: this.$refs.staticnav,
                offset: -100,
                force: true,
                cancelable: false,
                x: true,
                y: false
            }
            
           headerScroller(this.$refs[this.active][0].$el, 100, options)
          }
        }
      } catch (err) {
        console.warn(err)
      }
    },
    jump(id) {
      var options = {
          container: this.$refs.scrollContainer,
          offset: 0-this.$refs.staticnav.clientHeight,
          x: false,
          y: true
      }      
      this.$scrollTo(this.$refs[`entry-${id}`][0], 500, options)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  @import '../_main';


</style>



// WEBPACK FOOTER //
// src/components/Static.vue